import ApplicationController from './application_controller'

/* This is the custom StimulusReflex controller for the LineNumbering Reflex.
 * Learn more at: https://docs.stimulusreflex.com
 */
export default class extends ApplicationController {

  connect () {
    super.connect()
    // this.stimulate('LineNumbering#hello').then(res => console.log('res', res))
    this.editorMode = this.data.get('editorMode') == 'true'
    // console.log('editorMode', this.editorMode, this.data.get('editorMode'))
    // console.log('line_numbering_controller connected')
    this.initLineNumbering()
  }

  initLineNumbering() {
    console.log('initLineNumbering')
    // this.countParagraphs()
    console.log('line_numbering_type', this.data.get('type'))
    this.lineNumberType = this.data.get('type')
    if (this.lineNumberType === 'paragraph') {
      this.countParagraphs()
    } else if (this.lineNumberType === 'line') {
      if (!this.editorMode) {
        this.countLines()
      } else {
        // this.countEditorLines()
      }
    }
  }

  countParagraphs() {
    const trixDivs = this.element.getElementsByClassName('trix-content')

    if (trixDivs.length === 0) {
      console.warn('No trix-content div found')
      return
    }

    const lastTrixDiv = trixDivs[trixDivs.length - 1]

    // Make the container relative for absolute positioning
    lastTrixDiv.style.position = 'relative'

    // Remove existing paragraph numbers if any
    const existingNumbers = lastTrixDiv.getElementsByClassName('paragraph-number')
    Array.from(existingNumbers).forEach(el => el.remove())

    // Split the content into paragraphs
    const content = lastTrixDiv.innerHTML
    // console.log('content', content)
    // Split by both <br><br> and <div>&nbsp;</div>
    const paragraphs = content.split(/(?:<br><br>|<div>&nbsp;<\/div>)/)
    // console.log('paragraphs', paragraphs)

    // Create markers for each paragraph, handling both separator types
    let modifiedContent = content
      .replace(/(<br><br>|<div>&nbsp;<\/div>)/g, '$1<span class="paragraph-marker"></span>')
    // Add marker for the first paragraph
    modifiedContent = '<span class="paragraph-marker"></span>' + modifiedContent

    // Update the content with markers
    lastTrixDiv.innerHTML = modifiedContent

    // Get all markers and add numbers next to them
    const markers = lastTrixDiv.getElementsByClassName('paragraph-marker')
    Array.from(markers).forEach((marker, index) => {
      const numberSpan = document.createElement('span')
      numberSpan.className = 'paragraph-number'
      numberSpan.textContent = (index + 1).toString()
      numberSpan.style.cssText = `
        position: absolute;
        left: -20px;
        top: ${marker.offsetTop}px;
        color: #666;
        font-size: 14px;
        font-family: sans-serif;
      `
      lastTrixDiv.appendChild(numberSpan)
    })

    // Remove the temporary markers
    Array.from(markers).forEach(marker => marker.remove())

    // Store the count in a data attribute
    this.element.dataset.paragraphCount = paragraphs.length
  }

  countLines() {
    console.log('countLines')
    const trixDivs = this.element.getElementsByClassName('trix-content')

    if (trixDivs.length === 0) {
      console.log('No trix-content div found')
      return
    }

    const lastTrixDiv = trixDivs[trixDivs.length - 1]

    // Make the container relative for absolute positioning
    lastTrixDiv.style.position = 'relative'

    // Remove existing line numbers if any
    const existingNumbers = lastTrixDiv.getElementsByClassName('line-number')
    Array.from(existingNumbers).forEach(el => el.remove())

    // Split content into lines, excluding empty lines and headers
    const content = lastTrixDiv.innerHTML
    // console.log('content', content)

    // First, mark <br> tags that follow headers with a temporary class
    let modifiedContent = content
      .replace(/(<h[12][^>]*>.*?<\/h[12]>)([\s\S]*?)(<br>)/g, (match, header, middle, br) => {
        return header + middle + '<br class="skip-marker">'
      })
      // Then add markers after <br> tags that aren't marked to skip and aren't followed by another <br>
      .replace(/(<br(?![^>]*skip-marker)>)(?!<br>)/g, '$1<span class="line-marker"></span>')
      // Clean up the temporary class
      .replace(/<br class="skip-marker">/g, '<br>')

    // Add marker for the first line
    modifiedContent = '<span class="line-marker"></span>' + modifiedContent
    // console.log('modifiedContent', modifiedContent)

    // Update the content with markers
    lastTrixDiv.innerHTML = modifiedContent

    // Get all markers and add numbers next to them
    const markers = lastTrixDiv.getElementsByClassName('line-marker')
    Array.from(markers).forEach((marker, index) => {
      const lineNumber = index + 1

      // Skip line numbers based on mode
      if (!this.editorMode) {
        // In reading mode, only show line 4 and multiples of 5
        if (lineNumber !== 4 && lineNumber % 5 !== 0) {
          return
        }
      }

      const numberSpan = document.createElement('span')
      numberSpan.className = 'line-number'
      let left = -24
      // Show "Line" only for line 4
      if (!this.editorMode && lineNumber === 4) {
        numberSpan.textContent = 'Line'
        left = -36
      } else {
        numberSpan.textContent = lineNumber.toString()
      }

      numberSpan.style.cssText = `
        position: absolute;
        left: ${left}px;
        top: ${marker.offsetTop}px;
        color: #666;
        font-size: 14px;
        font-family: sans-serif;
      `
      lastTrixDiv.appendChild(numberSpan)
    })

    // Remove the temporary markers
    Array.from(markers).forEach(marker => marker.remove())
  }

  countEditorLines() {
    console.log('countEditorLines')
    const content = this.element.innerHTML

    // First remove div tags but keep their content, and remove HTML comments
    const cleanedContent = content
      .replace(/<div[^>]*>(.*?)<\/div>/g, '$1')
      .replace(/<!--.*?-->/g, '') // Remove HTML comments

    // Split content into elements while preserving other tags
    const elements = cleanedContent.split(/(<h[12][^>]*>.*?<\/h[12]>|<br>)/).filter(Boolean)
    console.log('elements', elements)

    let lineNumbers = []
    let currentLineNumber = 0
    let skipNextBr = false

    elements.forEach((element, index) => {
      if (element.match(/<h[12][^>]*>.*?<\/h[12]>/)) {
        // For headers, add null and set flag to skip next <br>
        lineNumbers.push(null)
        skipNextBr = true
      } else if (element === '<br>') {
        if (skipNextBr || (index > 0 && elements[index - 1] === '<br>')) {
          // If this <br> follows a header OR another <br>, add null
          lineNumbers.push(null)
          skipNextBr = false
        } else {
          // skip this <br> entirely
        }
      } else {
        // actual text content, push lineNumber
        currentLineNumber++
        lineNumbers.push(currentLineNumber)
      }
    })

    console.log('lineNumbers', lineNumbers)
    // return lineNumbers
    this.stimulate('LineNumbering#display_form_line_numbers', lineNumbers)
    // this.stimulate('LineNumberingReflex#hello')
  }
}
